module.exports = __webpack_public_path__ + "img/samsung-galaxy-e5.00ab895b.jpg";